import styled from 'styled-components';

export const WarningDiv = styled.div`
  align-self: center;
  color: ${({ theme }) => theme.colors.foreground.warning};
`;

export const WarningSpan = styled.span`
  color: ${({ theme }) => theme.colors.foreground.warning};
`;

export const PaddedSpan = styled.span`
  padding: 0 5px;
`;

export const Horizontal = styled.div`
  display: flex;
  flex-direction: row;
`;

export const InFormContainer = styled.div<{ tertiary?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, tertiary }) =>
    tertiary
      ? theme.colors.background.tertiary
      : theme.colors.background.secondary};
  padding: 5px;
`;
